import * as React from 'react';
import classNames from '../../utilities/class-names';

const ContributeIcon = ({ className }) => {
    return (<svg viewBox="0 0 16 17" className={classNames('docs-icon', className)} xmlns="http://www.w3.org/2000/svg">
    <path d="M13 10.2002V13.2002H3V3.2002H6V4.2002H4V12.2002H12V10.2002H13ZM13 3.2002H8L9.77812 4.9752L9.79375 4.99082L6 8.78457L7.41563 10.2002L11.2063 6.40645L13 8.2002V3.2002Z" />
</svg>)
}

export default ContributeIcon;